import React from 'react';
import ReactDOM from 'react-dom/client';
import { Chat } from './chat';

import './index.css';

const root = ReactDOM.createRoot(document.querySelector('#root')!);
root.render(
  <React.StrictMode>
    <Chat />
  </React.StrictMode>,
);
